import apiService from '../apiService'

export const sustainabilityController = configService => {
  const service = apiService(configService)

  return {
    downloadSustainability: params => {
      return service.downloadFile({
        url: `cms/buyer/sustain/form/download`,
        params,
      })
    },

    uploadSustainability: formData => {
      return service.uploadFile({
        url: `cms/buyer/sustain/form/upload?file`,
        formData,
      })
    },
  }
}
